import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PrButtonConfirmModule } from '../pr-button/pr-button-confirmation/pr-button-confirm.module';
import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrGedPickerModule } from '../pr-ged-picker/ged-picker.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';

import { GedDocumentCardComponent } from './ged-document-card.component';

@NgModule({
  declarations: [GedDocumentCardComponent],
  imports: [
    CommonModule,
    PrButtonConfirmModule,
    PrButtonModule,
    PrGedPickerModule,
    PrIconModule,
  ],
  exports: [GedDocumentCardComponent],
})
export class PrGedDocumentCardModule {}
